const quizStatuses = {
    OPEN: 'open',
    PASSED: 'passed',
    FAILED: 'failed'
}

const ctaTypes = {
    NEXT_GOAL: 'next-goal',
    RETURN_TO_GOAL: 'return-to-goal',
    NEXT_MODULE: 'next-module'
}

export {quizStatuses, ctaTypes}
